import Yup from '../../../../utils/yup';
import errors from '../../../../static/errors.json';

export const EVENT_NOTIFICATIONS: EventNotification[] = [
  {
    name: 'User Updates',
    code: '1',
    tooltipText: 'Event Notification for general user updates',
    on: false,
  },
];

export interface EventNotification {
  name: string;
  code: string;
  tooltipText: string;
  on: boolean;
}

export const endpointConfigurationSchema = (isEdit: boolean) =>
  Yup.object().shape({
    url: Yup.string()
      .required(errors.validation.url.required)
      .matches(
        /^https?:\/\/[A-Za-z0-9.-]+\.[A-Za-z]{2,}(?:[/:?#].*)?$/i,
        errors.validation.url.invalid
      ),
    username: Yup.string()
      .required(errors.validation.username.required)
      .min(8, errors.validation.username.invalid),
    password: isEdit
      ? Yup.string().notRequired()
      : Yup.string().required(errors.validation.password.required),
  });

export const generatePassword = () => {
  const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  const specials = '*$!';
  const length = 16 + Math.floor(Math.random() * 5);
  const array = new Uint8Array(length);
  crypto.getRandomValues(array);

  let password = '';
  for (let i = 0; i < length - 3; i++) {
    password += chars[array[i] % chars.length];
  }
  for (let i = length - 3; i < length; i++) {
    password += specials[array[i] % 3];
  }

  return password
    .split('')
    .sort(() => array[0] - 128)
    .join('');
};
